const CropPlaningReport = {

    // FIELDS
    "farm": "Farm",
    "crop": "Crop",
    "status": "Status",
    "from_date": "From Date",
    "to_date": "To Date",

    // PAGE HEADER
    "crop_planing_report": "Crop Planing Report",

    // TOAST
    "success_download": "Downloaded Successfully",

    // TOOLTIP
    "preview": "Preview",
    "download": "Excel Download",
    "change_status": "Change Status",

    // TABLE HEADER
    "table_farm": "FARM",
    "table_crop": "CROP",
    "table_start_date": "START DATE",
    "table_end_date": "END DATE",
    "table_status": "STATUS",
    "table_created_at": "CREATED AT",

}

export default CropPlaningReport;
